<template>
    <div id="user-management">
        <!-- begin breadcrumb -->
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'User Management' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">User Management</h3>

        <v-card>
            <v-card-title>
                Daftar User
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider />
            <!-- begin datatable User Management -->
            <app-datatable
                :items="users"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="true"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="pageNumber"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="goToDetail"
                v-on:changePage="pageNumber = $event"
                v-on:doSearch="
                    query = $event;
                    loadUserData();
                "
            ></app-datatable>
            <!-- end datatable User Management -->
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-s";

export default {
    name: "user-management",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            query: "",
            isLoading: false,
            group: null,
            page: 100,
            pageNumber: 1,
            visibleRow: { text: "Row : 25", value: 25 },
            ascd: { text: "Baru ke Lama", value: 1 },
            users: [],
            headers: [
                { text: "No Siswa", value: "student_number", width: 150 },
                { text: "Nama Siswa", value: "name", width: 200 },
                { text: "Email", value: "email", width: 200 },
                { text: "Kontak", value: "phone_number", width: 200 },
                { text: "Sekolah", value: "school", width: 200 },
                { text: "Grup Kelas", value: "group_schedule", width: 200 },
                { text: "Tipe User", value: "status", width: 150 },
                { text: "Aktif Sampai", value: "expired_at", width: 150 },
            ],
        };
    },

    watch: {
        pageNumber: function (newVal) {
            this.loadUserData(newVal);
        },
    },

    methods: {
        // not used
        toggleOrder() {
            this.sortDesc = !this.sortDesc;
        },

        // Get all data User Management
        loadUserData: function (pageNumber = 1) {
            var context = this;
            var token = this.$ls.get("token");
            var url = process.env.API_BASE_URL + "account/usman/users";

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    page: pageNumber,
                    search_by: "name",
                    search: this.query,
                    query: this.query ? this.query : null,
                },
            })
                .then(function (response) {
                    context.users = response.data.users;
                    context.users.forEach((element, index) => {
                        element.no = index;
                        element.school = element.school ? element.school : "-";
                        element.group_schedule = element.group_schedule || null;
                        // if (element.group_schedule) {
                        //   context.getJadwalKelas(index, element.group_schedule);
                        // } else {
                        element.group_schedule = "-";
                        // }
                        element.phone_number = element.phone_number
                            ? element.phone_number
                            : "-";
                        element.student_number = element.student_number
                            ? element.student_number
                            : "-";
                        element.status = element.is_nf_student
                            ? "Siswa NF"
                            : "-";
                    });
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        // get index data in datatable and redirect page by user id
        goToDetail: function (index, data = null) {
            if (data != null) {
                this.users.forEach((element, i) => {
                    if (element.user_id === data.item.user_id) {
                        index = i;
                    }
                });
                this.$store.commit("usman_init", index);
                this.$store.commit("package_init", index);
                this.$router.push({
                    path: "user-detail",
                    query: { id: index.user_id },
                });
            } else {
                this.$store.commit("usman_init", this.users[index]);
                this.$store.commit("package_init", this.users[index]);
                this.$router.push({
                    path: "user-detail",
                    query: { id: this.users[index].user_id },
                });
            }
        },

        // Joining all data group_schedule in data User Management with data Jadwal Kelas by group_schedule
        getJadwalKelas: function (index, group_schedule) {
            var context = this;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "payment/package/group/" +
                group_schedule +
                "/detail";

            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });
            http.get(url)
                .then(function (response) {
                    context.users[index].group_schedule =
                        response.data.description;
                })
                .catch(function (error) {
                    console.log(error.message);
                })
                .then(function () {
                    context.isLoading = false;
                });
        },
    },

    mounted: function () {
        this.loadUserData();
    },
};
</script>



// WEBPACK FOOTER //
// UserManagement.vue?4c635ccd